"use client";

import React, { useRef, useState } from "react";
import styles from "./gradient-cursor-follower.module.scss";
import classNames from "classnames";

interface CursorPos {
  x: number;
  y: number;
}

const GradientCursorFollower = () => {
  const [cursorPos, setCursorPos] = useState<CursorPos>({
    x: 0,
    y: 0,
  });
  const parentRef = useRef<HTMLDivElement>(null);

  const handleMouseMove = (e: React.MouseEvent) => {
    if (parentRef.current) {
      const parentRect = parentRef.current.getBoundingClientRect();
      const mouseX = e.clientX - parentRect.left;
      const mouseY = e.clientY - parentRect.top;
      setCursorPos({ x: mouseX - 150, y: mouseY + 150 });
    }
  };

  return (
    <div ref={parentRef} className={styles.container} onMouseMove={handleMouseMove}>
      <div className={classNames(styles.blob)} style={{ transform: `translate3d(calc(${cursorPos.x}px), calc(${cursorPos.y}px - 100%), 0)` }} />
    </div>
  );
};

export default GradientCursorFollower;
